export default {
      id: "icon-search-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-search",
      toString: function () {
        return this.url;
      }
    }